// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Fly To 🛒 Shopping Cart Animation With Vanilla JavaScript
👨🏻‍⚕️ By: Coding Design

You can do whatever you want with the code. However if you love my content, you can subscribed my YouTube Channel
🌎link: www.youtube.com/codingdesign
 */

:root {
	--primary: #333;
	/* --primary: #fff; */
	--secondary: #00dd53;
	--bg: #0e1523;
	/* --bg: #f5f5f5; */
}

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	/* background-color: var(--bg); */
	overflow-x: hidden;
}

.slider {
	/* background-color: var(--bg); */
	padding: 1rem;

	margin: 2rem auto;
	display: flex;
	/* display: grid;
    grid-template-columns: repeat(4, 1fr);
    place-items: center;
    grid-gap: 2rem; */

	font: normal 1rem sans-serif;
}

.product-card {
	position: relative;
	left: 0;

	min-width: 17rem;
	height: 23rem;
	background-color: var(--primary);
	color: #fff;
	border-radius: 1rem;
	border: 0.1rem solid transparent;

	box-shadow: 0 0.2rem 0.6rem #0003;
	transition: 0.5s ease-in-out;
}

@media screen and (max-width: 768px) {
	.product-card {
		min-width: 21rem;
	}
}

.product-card:not(:first-child) {
	margin-left: 2rem;
}

.product-card:first-child {
	margin-left: 0.4rem;
}

.product-card:hover {
	border: 0.1rem solid var(--secondary);
	transform: scale(1.05);
}

.product-card-content {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	overflow: hidden;
	border-radius: inherit;

	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
}

.product-card-content::before,
.product-card-content::after {
	/* position: absolute;
    content: "";
    background-color: var(--secondary);
    border-radius: 50%;
    transition: .5s ease-in-out; */
}

.product-card-content::before {
	/* top: -6%;
    right: -6%;
    width: 9rem;
    height: 9rem; */
}

.product-card-content::after {
	/* bottom: -6%;
    left: -6%;
    width: 5rem;
    height: 5rem; */
}

.product-card-content:hover::before {
	/* transform: scale(1.8); */
}

.product-card-content:hover::after {
	/* transform: scale(0); */
}

.product-card-img,
.product-card-title {
	transform: translateY(4rem);
	transition: 0.5s ease-in-out;
}

.product-card-img {
	width: auto;
	height: 9.5rem;
}

.product-card-title {
	font-size: 1rem;
	text-transform: capitalize;
	transition-delay: 0.1s;
}

.product-card-body,
.product-card-footer {
	transform: translateY(8rem);
	transition: 0.5s ease-in-out;
	display: flex;
	gap: 1rem;
}

.product-card-body {
	width: 100%;

	display: flex;
	justify-content: space-around;
	align-items: center;

	transition-delay: 0.2s;
}

.product-card:hover .product-card-img,
.product-card:hover .product-card-title,
.product-card:hover .product-card-body,
.product-card:hover .product-card-footer {
	transform: translateY(0);
}

.product-card-footer {
	transition-delay: 0.3s;
}

.star {
	font-size: 1.4rem;
	color: gold;
}

.product-card-price {
	font: bolder 1.5rem sans-serif;
}

.btn {
	padding: 0.3rem 1rem;
	background-color: unset;
	border: none;
	outline: none;
	border-radius: 0.5rem;
	color: #fff;
	cursor: pointer;
	font-size: 16px;
}
.btn:hover {
	color: #fff !important;
}

.btn-success {
	background-color: var(--secondary);
}

.btn-border {
	border: 0.1rem solid var(--secondary);
}

.arrow {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);

	width: 3rem;
	height: 3rem;
	background-color: #fff;
	color: #000;

	border-radius: 50%;
	outline: 0.5rem solid transparent;
	font: 800 1.5rem sans-serif;
	text-align: center;
	line-height: 3rem;
	-webkit-user-select: none;
	        user-select: none;

	cursor: pointer;
	transition: 0.5s ease-in-out;

	/* prevent from hiding when flying img animation take place */
	z-index: 200;
}

.arrow:active {
	background-color: #ddd;
	/* background-color: #666; */
}

.left {
	left: 1rem;
}

.right {
	right: 1rem;
}

.shopping-cart {
	/* position: absolute; */
	/* right: 1rem; */
	/* top: 1rem; */
	display: flex;
	align-items: center;
	justify-content: center;
	/* width: 3rem; */
	height: 3rem;
	/* background-color: #f0f2f5; */
	border-radius: 50%;
	outline: 0.5rem solid transparent;

	text-align: center;
	line-height: 4rem;

	cursor: pointer;
	/* box-shadow: 0 0.2rem 0.6rem #0006; */
	transition: 0.5s ease-in-out;
}

.shopping-cart.active {
	/* width: 8rem; */
	/* border-radius: .8rem; */
}

.shopping-cart.active > span {
	/* margin-left: -4rem; */
}

.arrow:hover,
/* .shopping-cart:hover {
	outline: 0.5rem solid #fff5;
} */

.shopping-cart::before {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	content: attr(data-product-count);
	top: -0.39rem;
	right: -0.6rem;
	/* top: -0.61rem;
	right: -0.3rem; */
	width: 1.3rem;
	height: 1.3rem;

	color: #fff;
	background-color: red;
	font-family: 'Roboto';
	border-radius: 50%;
	text-align: center;
	line-height: 2rem;
	font-size: 13px;
}

@media screen and (min-width: 0px) and (max-width: 520px) {
	.shopping-cart::before {
		font-size: 12px;
	}
}

.product-card-icon {
	font-size: 1.5rem;
	transition: 0.5s ease-in-out;
}

/* For Js Code */

.flying-img {
	position: absolute;
	animation: fly_to_cart 1s ease-in-out;
}

@keyframes fly_to_cart {
	0% {
		left: 0;
		top: 0;
	}
	45%,
	50% {
		left: var(--left);
		top: 60px;
	}
	80%,
	90% {
		left: var(--left);
		top: var(--top);
		transform: scale(0.2);
	}
	100% {
		left: calc(var(--left) + 40px);
		top: var(--top);
		transform: scale(0.2);
	}
}

.owl-dots {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styled/cart.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;CACC,eAAe;CACf,qBAAqB;CACrB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,aAAa;;CAEb,iBAAiB;CACjB,aAAa;CACb;;;qBAGoB;;CAEpB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,OAAO;;CAEP,gBAAgB;CAChB,aAAa;CACb,gCAAgC;CAChC,WAAW;CACX,mBAAmB;CACnB,gCAAgC;;CAEhC,iCAAiC;CACjC,4BAA4B;AAC7B;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;;CAEZ,gBAAgB;CAChB,sBAAsB;;CAEtB,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;;CAEC;;;;kCAIiC;AAClC;;AAEA;CACC;;;mBAGkB;AACnB;;AAEA;CACC;;;mBAGkB;AACnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;AACvB;;AAEA;;CAEC,2BAA2B;CAC3B,4BAA4B;CAC5B,aAAa;CACb,SAAS;AACV;;AAEA;CACC,WAAW;;CAEX,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;;CAEnB,sBAAsB;AACvB;;AAEA;;;;CAIC,wBAAwB;AACzB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,oBAAoB;CACpB,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,eAAe;AAChB;AACA;CACC,sBAAsB;AACvB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;;CAE3B,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,WAAW;;CAEX,kBAAkB;CAClB,iCAAiC;CACjC,2BAA2B;CAC3B,kBAAkB;CAClB,iBAAiB;CACjB,yBAAiB;SAAjB,iBAAiB;;CAEjB,eAAe;CACf,4BAA4B;;CAE5B,6DAA6D;CAC7D,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,4BAA4B;AAC7B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;CACZ,+BAA+B;CAC/B,kBAAkB;CAClB,iCAAiC;;CAEjC,kBAAkB;CAClB,iBAAiB;;CAEjB,eAAe;CACf,uCAAuC;CACvC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;;;;;CAMC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,iCAAiC;CACjC,aAAa;CACb,cAAc;CACd;kBACiB;CACjB,aAAa;CACb,cAAc;;CAEd,WAAW;CACX,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,4BAA4B;AAC7B;;AAEA,gBAAgB;;AAEhB;CACC,kBAAkB;CAClB,qCAAqC;AACtC;;AAEA;CACC;EACC,OAAO;EACP,MAAM;CACP;CACA;;EAEC,iBAAiB;EACjB,SAAS;CACV;CACA;;EAEC,iBAAiB;EACjB,eAAe;EACf,qBAAqB;CACtB;CACA;EACC,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;CACtB;AACD;;AAEA;CACC,aAAa;AACd","sourcesContent":["/*\nFly To 🛒 Shopping Cart Animation With Vanilla JavaScript\n👨🏻‍⚕️ By: Coding Design\n\nYou can do whatever you want with the code. However if you love my content, you can subscribed my YouTube Channel\n🌎link: www.youtube.com/codingdesign\n */\n\n:root {\n\t--primary: #333;\n\t/* --primary: #fff; */\n\t--secondary: #00dd53;\n\t--bg: #0e1523;\n\t/* --bg: #f5f5f5; */\n}\n\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\nbody {\n\t/* background-color: var(--bg); */\n\toverflow-x: hidden;\n}\n\n.slider {\n\t/* background-color: var(--bg); */\n\tpadding: 1rem;\n\n\tmargin: 2rem auto;\n\tdisplay: flex;\n\t/* display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    place-items: center;\n    grid-gap: 2rem; */\n\n\tfont: normal 1rem sans-serif;\n}\n\n.product-card {\n\tposition: relative;\n\tleft: 0;\n\n\tmin-width: 17rem;\n\theight: 23rem;\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n\tborder-radius: 1rem;\n\tborder: 0.1rem solid transparent;\n\n\tbox-shadow: 0 0.2rem 0.6rem #0003;\n\ttransition: 0.5s ease-in-out;\n}\n\n@media screen and (max-width: 768px) {\n\t.product-card {\n\t\tmin-width: 21rem;\n\t}\n}\n\n.product-card:not(:first-child) {\n\tmargin-left: 2rem;\n}\n\n.product-card:first-child {\n\tmargin-left: 0.4rem;\n}\n\n.product-card:hover {\n\tborder: 0.1rem solid var(--secondary);\n\ttransform: scale(1.05);\n}\n\n.product-card-content {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\n\toverflow: hidden;\n\tborder-radius: inherit;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n.product-card-content::before,\n.product-card-content::after {\n\t/* position: absolute;\n    content: \"\";\n    background-color: var(--secondary);\n    border-radius: 50%;\n    transition: .5s ease-in-out; */\n}\n\n.product-card-content::before {\n\t/* top: -6%;\n    right: -6%;\n    width: 9rem;\n    height: 9rem; */\n}\n\n.product-card-content::after {\n\t/* bottom: -6%;\n    left: -6%;\n    width: 5rem;\n    height: 5rem; */\n}\n\n.product-card-content:hover::before {\n\t/* transform: scale(1.8); */\n}\n\n.product-card-content:hover::after {\n\t/* transform: scale(0); */\n}\n\n.product-card-img,\n.product-card-title {\n\ttransform: translateY(4rem);\n\ttransition: 0.5s ease-in-out;\n}\n\n.product-card-img {\n\twidth: auto;\n\theight: 9.5rem;\n}\n\n.product-card-title {\n\tfont-size: 1rem;\n\ttext-transform: capitalize;\n\ttransition-delay: 0.1s;\n}\n\n.product-card-body,\n.product-card-footer {\n\ttransform: translateY(8rem);\n\ttransition: 0.5s ease-in-out;\n\tdisplay: flex;\n\tgap: 1rem;\n}\n\n.product-card-body {\n\twidth: 100%;\n\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\n\ttransition-delay: 0.2s;\n}\n\n.product-card:hover .product-card-img,\n.product-card:hover .product-card-title,\n.product-card:hover .product-card-body,\n.product-card:hover .product-card-footer {\n\ttransform: translateY(0);\n}\n\n.product-card-footer {\n\ttransition-delay: 0.3s;\n}\n\n.star {\n\tfont-size: 1.4rem;\n\tcolor: gold;\n}\n\n.product-card-price {\n\tfont: bolder 1.5rem sans-serif;\n}\n\n.btn {\n\tpadding: 0.3rem 1rem;\n\tbackground-color: unset;\n\tborder: none;\n\toutline: none;\n\tborder-radius: 0.5rem;\n\tcolor: #fff;\n\tcursor: pointer;\n\tfont-size: 16px;\n}\n.btn:hover {\n\tcolor: #fff !important;\n}\n\n.btn-success {\n\tbackground-color: var(--secondary);\n}\n\n.btn-border {\n\tborder: 0.1rem solid var(--secondary);\n}\n\n.arrow {\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\n\twidth: 3rem;\n\theight: 3rem;\n\tbackground-color: #fff;\n\tcolor: #000;\n\n\tborder-radius: 50%;\n\toutline: 0.5rem solid transparent;\n\tfont: 800 1.5rem sans-serif;\n\ttext-align: center;\n\tline-height: 3rem;\n\tuser-select: none;\n\n\tcursor: pointer;\n\ttransition: 0.5s ease-in-out;\n\n\t/* prevent from hiding when flying img animation take place */\n\tz-index: 200;\n}\n\n.arrow:active {\n\tbackground-color: #ddd;\n\t/* background-color: #666; */\n}\n\n.left {\n\tleft: 1rem;\n}\n\n.right {\n\tright: 1rem;\n}\n\n.shopping-cart {\n\t/* position: absolute; */\n\t/* right: 1rem; */\n\t/* top: 1rem; */\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t/* width: 3rem; */\n\theight: 3rem;\n\t/* background-color: #f0f2f5; */\n\tborder-radius: 50%;\n\toutline: 0.5rem solid transparent;\n\n\ttext-align: center;\n\tline-height: 4rem;\n\n\tcursor: pointer;\n\t/* box-shadow: 0 0.2rem 0.6rem #0006; */\n\ttransition: 0.5s ease-in-out;\n}\n\n.shopping-cart.active {\n\t/* width: 8rem; */\n\t/* border-radius: .8rem; */\n}\n\n.shopping-cart.active > span {\n\t/* margin-left: -4rem; */\n}\n\n.arrow:hover,\n/* .shopping-cart:hover {\n\toutline: 0.5rem solid #fff5;\n} */\n\n.shopping-cart::before {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tcontent: attr(data-product-count);\n\ttop: -0.39rem;\n\tright: -0.6rem;\n\t/* top: -0.61rem;\n\tright: -0.3rem; */\n\twidth: 1.3rem;\n\theight: 1.3rem;\n\n\tcolor: #fff;\n\tbackground-color: red;\n\tfont-family: 'Roboto';\n\tborder-radius: 50%;\n\ttext-align: center;\n\tline-height: 2rem;\n\tfont-size: 13px;\n}\n\n@media screen and (min-width: 0px) and (max-width: 520px) {\n\t.shopping-cart::before {\n\t\tfont-size: 12px;\n\t}\n}\n\n.product-card-icon {\n\tfont-size: 1.5rem;\n\ttransition: 0.5s ease-in-out;\n}\n\n/* For Js Code */\n\n.flying-img {\n\tposition: absolute;\n\tanimation: fly_to_cart 1s ease-in-out;\n}\n\n@keyframes fly_to_cart {\n\t0% {\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\t45%,\n\t50% {\n\t\tleft: var(--left);\n\t\ttop: 60px;\n\t}\n\t80%,\n\t90% {\n\t\tleft: var(--left);\n\t\ttop: var(--top);\n\t\ttransform: scale(0.2);\n\t}\n\t100% {\n\t\tleft: calc(var(--left) + 40px);\n\t\ttop: var(--top);\n\t\ttransform: scale(0.2);\n\t}\n}\n\n.owl-dots {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
